import React, { useContext, useMemo } from 'react';
import { PlatformHeader } from './components/header';
import ChatMCPComponent from './components/ChatMCP';
import { AuthContext } from './authContext';
import { ChatMCPProps } from './interfaces/chatMCPProps';
import './App.css';

// Main application component
const App: React.FC = () => {
  const authContext = useContext(AuthContext);

  const props: ChatMCPProps = useMemo(
    () => ({
      authContext: authContext,
    }),
    [authContext]
  );

  return (
    <div className="app-container">
      <PlatformHeader />
      <ChatMCPComponent {...props} />
    </div>
  );
};

export default App;
